var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['profile-short', !_vm.url ? 'placeholder' : ''],attrs:{"id":_vm.id,"tabindex":"0"}},[(_vm.url)?_c('img',{attrs:{"src":_vm.url,"alt":"Profile Image"}}):_c('span',[_vm._v(_vm._s(_vm.placeholder))])])}
var staticRenderFns = []

export { render, staticRenderFns }